import './styles/main.scss';
import {sphereAppInitialise} from './app/initialise';

window.addEventListener('load', () => {
  const planogramName = window.location.pathname.split('/').slice(1)[0];

  sphereAppInitialise(planogramName);
});
